import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import {
  allowedSystemPackageFilesExtensions,
  transformSystemPackageApplicationFileListToSelect,
} from '../application-version-fields/applicationVersionFields.util';
import type {
  UseSystemPackageVersionBuildStepParams,
  UseSystemPackageVersionBuildStepReturn,
} from './systemPackageVersionBuildStep.model';

export function useSystemPackageVersionBuildStep({
  applicationFiles,
  control,
}: UseSystemPackageVersionBuildStepParams): UseSystemPackageVersionBuildStepReturn {
  const inputOptions = useMemo(
    () => ({
      existingAppFiles: transformSystemPackageApplicationFileListToSelect(applicationFiles),
    }),
    [applicationFiles],
  );

  const allowedFileExtensions = useMemo(() => allowedSystemPackageFilesExtensions, []);

  const applicationFilesValue = useWatch({ control, name: 'build.applicationFiles' });
  const existingAppFilesValue = useWatch({ control, name: 'build.existingAppFiles' });

  const shouldFieldsBeRequired = useMemo(
    () => !existingAppFilesValue?.length && !applicationFilesValue?.length,
    [existingAppFilesValue, applicationFilesValue],
  );

  return useMemo(
    () => ({
      inputOptions,
      allowedFileExtensions,
      isApplicationFilesRequired: shouldFieldsBeRequired,
      isExistingAppFilesRequired: shouldFieldsBeRequired,
    }),
    [inputOptions, allowedFileExtensions, shouldFieldsBeRequired],
  );
}
